<template>

    <div class="custom-slick">
        <div class="desktop">
            <slick
                ref="customSlick"
                :options="options"
                @beforeChange="handleBeforeChange"
            >
                <article v-for="(item, index) of data" :key="index">
                    <img :src="item.desktop" alt="" />
                </article>
            </slick>
            <!-- nav -->
            <div class="hero-nav flex content-max-width">
                <div
                    class="item"
                    :class="{ inactive: currentSlide !== i }"
                    v-for="(nav, i) in data"
                    :key="i"
                    @click="goTo(i)"
                >
                    <div class="inner">
                        <h3>{{ nav.title }}</h3>
                        <p class="desc" v-if="currentSlide === i">{{ nav.lead_copy }}</p>
                    </div>
                    <div class="divider" v-if="currentSlide !== i"></div>
                    <div class="button" v-if="currentSlide === i">
                        <a :href="nav.url">
            <span class="flex">
              {{ nav.button_text }}
              <img src="/images/icons/arrow-right.svg" alt="" />
            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile">
            <slick
                ref="customSlickMobile"
                :options="options"
                @beforeChange="handleBeforeChange"
            >
                <article v-for="(item, index) of data" :key="index">

                    <div class="header-content">
                        <img class="full-image" :src="item.desktop" alt="" />

                        <div class="item content-max-width">
                            <div >
                                <h3>{{ item.title }}</h3>
                                <p class="desc">{{ item.lead_copy }}</p>
                            </div>
                            <div class="button">
                                <a :href="item.url">
                        <span class="flex">
                          {{ item.button_text }}
                          <img src="/images/icons/arrow-right.svg" alt="" />
                        </span>
                                </a>
                            </div>
                        </div>

                    </div>

                </article>
            </slick>

        </div>

    </div>




</template>

<script>
import Slick from "vue-slick";

export default {
  props: ["data"],
  components: {
    slick: Slick,
  },
  data() {
    return {
      currentSlide: 0,
      options: {
        dots: true,
        infinite: true,
        speed: 300,
        fade: true,
        arrows: false,
        autoPlay: false,
        slidesToShow: 1
      }
    };
  },
  methods: {
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      this.currentSlide = nextSlide;
    },
    goTo(slideIndex) {
      this.$refs.customSlick.goTo(slideIndex);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/HeroSlider.vue